import React, {createContext, useContext, useEffect, useState} from "react";

import api from "../api";

const ProjectContext = createContext({
	info: {},
	loading: false,
	error: null,
});

export const useProject = () => useContext(ProjectContext);

export const ProjectProvider = ({children}) => {
	const pathname = window.location.pathname;
	const parts = pathname.split("/");
	const id = parts[1] === "projects" && parts[2] ? parts[2] : null;

	const [info, setInfo] = useState({});
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);

	useEffect(() => {
		if (id && id !== "*" && info._id !== id) {
			setLoading(true);
			api.get(`/projects/${id}/info`)
				.then(response => {
					setInfo(response.data);
					setLoading(false);
				})
				.catch(err => {
					console.error("Failed to load project info", err);
					setError(err);
					setLoading(false);
				});
		}
	}, [id]);

	return <ProjectContext.Provider value={{info, loading, error}}>{children}</ProjectContext.Provider>;
};
